export default __webpack_public_path__ + "4033e8518aad7a71402ae08c3d00f88e.woff2";